module.exports = __webpack_public_path__ + "static/media/regalo_receive.5406ca3a.png";